// Central content + asset definitions for the M N Savanur wholesale website.

const px = (id, w = 1200) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
const pxPng = (id, w = 1200) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.png?auto=compress&cs=tinysrgb&w=${w}`;
const un = (path, w = 1400) =>
  `https://images.unsplash.com/${path}?auto=format&fit=crop&w=${w}&q=80`;

export const BUSINESS = {
  name: "M N Savanur",
  tagline: "Wholesale Vegetable & Spice Merchants",
  phone: "7676011496",
  phoneDisplay: "+91 76760 11496",
  whatsapp: "917676011496",
  whatsappMessage: "Hello, I want to enquire about wholesale products.",
  addressLines: [
    "Shop No. 57,",
    "A.P.M.C Market Yard,",
    "Amargol,",
    "Hubli - 580025, Karnataka, India",
  ],
  mapsEmbed:
    "https://www.google.com/maps?q=APMC+Market+Yard+Amargol+Hubli+Karnataka+580025&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=APMC+Market+Yard+Amargol+Hubli+Karnataka+580025",
};

export const IMAGES = {
  heroBg:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_vegetable-harvest-co/artifacts/nesjbjok_shop%201.png",
  market:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_vegetable-harvest-co/artifacts/o3eo4dye_image.png",
  storefront:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_vegetable-harvest-co/artifacts/4rgyb28b_ChatGPT%20Image%20Jul%203%2C%202026%2C%2012_45_29%20PM.png",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Products", href: "#products" },
  { label: "Services", href: "#services" },
  { label: "About Us", href: "#about" },
  { label: "Why Us", href: "#why-us" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const TRUST_BADGES = [
  "Premium Quality",
  "Bulk Supply",
  "Fast Delivery",
  "Custom Packaging",
];

export const PRODUCTS = [
  { id: "onion", name: "Onion", desc: "Farm fresh red onions sorted daily for the best size and shelf life.", img: "https://customer-assets-cm19k8pv.emergentagent.net/job_vegetable-harvest-co/artifacts/0db0shaj_image.png" },
  { id: "potato", name: "Potato", desc: "Premium quality with consistent fresh stock.", img: un("photo-1518977676601-b53f82aba655") },
  { id: "garlic", name: "Garlic", desc: "Farm fresh bulbs available in multiple sizes.", img: px(12955789) },
  { id: "ginger", name: "Ginger", desc: "Fresh ginger with strong aroma and long-lasting freshness.", img: "https://customer-assets-cm19k8pv.emergentagent.net/job_vegetable-harvest-co/artifacts/zu6fgasg_image.png" },
  { id: "red-chilli", name: "Red Chilli", desc: "Sun-dried, deep-red whole chillies with rich colour and heat.", img: "https://customer-assets-cm19k8pv.emergentagent.net/job_vegetable-harvest-co/artifacts/it606qlo_image.png" },
  { id: "red-chilli-powder", name: "Red Chilli Powder", desc: "Hygienically ground and packed.", img: "https://customer-assets-cm19k8pv.emergentagent.net/job_vegetable-harvest-co/artifacts/l0u6ubqy_image.png" },
  { id: "tamarind", name: "Tamarind", desc: "Different grades available for every need.", img: un("photo-1771229389277-a0a7546913f9") },
  { id: "masala-chutney", name: "Homemade Taste Masala Chutney", desc: "Homemade-taste masala and chutney blends, ready for retailers and distributors.", img: "https://customer-assets-cm19k8pv.emergentagent.net/job_vegetable-harvest-co/artifacts/3oxofz1n_image.png" },
];

export const PRODUCT_NAMES = PRODUCTS.map((p) => p.name);

export const SERVICES = [
  { icon: "Sprout", title: "Fresh Vegetable Wholesale", desc: "Premium Onion, Potato, Garlic & Ginger in bulk quantities." },
  { icon: "Flame", title: "Spice Supply", desc: "Red Chilli, Chilli Powder and wholesale spice products." },
  { icon: "Leaf", title: "Tamarind Supply", desc: "High-quality tamarind available in different grades." },
  { icon: "Soup", title: "Homemade Taste Masala Chutney", desc: "Wholesale supply of masala & chutney for retailers and distributors." },
  { icon: "PackageCheck", title: "Bulk Orders", desc: "Supply for retailers, supermarkets, hotels, restaurants & caterers." },
  { icon: "Truck", title: "Fast Delivery", desc: "Reliable, on-time delivery for business customers." },
  { icon: "Package", title: "Custom Packaging", desc: "1 kg, 5 kg, 10 kg, 25 kg, 50 kg or custom packing as required." },
  { icon: "Building2", title: "B2B Supply", desc: "Long-term supply partnerships for businesses across Karnataka." },
];

export const WHY_CHOOSE_US = [
  { icon: "Award", title: "Premium Quality Products" },
  { icon: "Sun", title: "Fresh Daily Stock" },
  { icon: "BadgeIndianRupee", title: "Competitive Wholesale Prices" },
  { icon: "ShieldCheck", title: "Trusted Supplier" },
  { icon: "Boxes", title: "Bulk Quantity Available" },
  { icon: "Truck", title: "Reliable Delivery" },
  { icon: "Package", title: "Flexible Packaging" },
  { icon: "Headset", title: "Excellent Customer Support" },
];

export const STATS = [
  { value: 500, suffix: "+", label: "Business Customers" },
  { value: 1000, suffix: "+", label: "Bulk Orders Completed" },
  { value: 10, suffix: "+", label: "Products" },
  { value: 100, suffix: "%", label: "Quality Commitment" },
];

export const GALLERY = [
  { src: "https://customer-assets-cm19k8pv.emergentagent.net/job_vegetable-harvest-co/artifacts/0db0shaj_image.png", caption: "Onion sacks" },
  { src: un("photo-1518977676601-b53f82aba655", 1000), caption: "Potato bags" },
  { src: px(12955789, 1000), caption: "Garlic" },
  { src: px(10112136, 1000), caption: "Ginger" },
  { src: px(2802527, 1000), caption: "Red chilli" },
  { src: un("photo-1771229389277-a0a7546913f9", 1000), caption: "Tamarind" },
  { src: px(1267338, 1000), caption: "Warehouse" },
  { src: px(1427107, 1000), caption: "Loading vehicle" },
  { src: px(1300972, 1000), caption: "APMC market" },
  { src: px(4393021, 1000), caption: "Packaging" },
  { src: px(17870116, 1000), caption: "Spice market" },
  { src: pxPng(8760461, 1000), caption: "Red chilli powder" },
];

export const FAQS = [
  {
    q: "What products do you supply?",
    a: "We supply premium quality Onion, Potato, Garlic, Ginger, Tamarind, Red Chilli, Red Chilli Powder, and a range of Masala and Chutney products in wholesale bulk quantities.",
  },
  {
    q: "Do you provide bulk orders?",
    a: "Yes. Bulk supply is our core business. We serve retailers, supermarkets, hotels, restaurants, caterers and food distributors with consistent quality and dependable delivery.",
  },
  {
    q: "Can you customize packaging?",
    a: "Absolutely. We offer flexible packaging in 1 kg, 5 kg, 10 kg, 25 kg and 50 kg, or custom packing as per your business requirement.",
  },
  {
    q: "Do you deliver outside Hubli?",
    a: "Yes, we provide reliable delivery for business customers across Karnataka. Share your location when requesting a quote and we will confirm delivery.",
  },
  {
    q: "How can I request wholesale pricing?",
    a: "Simply call us at 7676011496, message us on WhatsApp, or fill in the quote form on this page with your product and quantity. We will respond with competitive wholesale pricing.",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "The Market",
    body: "Rooted in the A.P.M.C Market Yard of Hubli, M N Savanur is a trusted wholesale trader supplying premium agricultural produce in bulk to businesses across Karnataka.",
  },
  {
    no: "02",
    title: "The Produce",
    body: "We specialise in Onion, Potato, Garlic, Ginger, Tamarind, Red Chilli, Red Chilli Powder, Masala and Chutney products — sourced fresh and graded for consistent quality.",
  },
  {
    no: "03",
    title: "Your Reliable Wholesale Partner",
    body: "Whether you own a retail shop, supermarket, hotel, restaurant or catering business, M N Savanur is committed to providing timely delivery, consistent quality and long-term business relationships you can trust.",
  },
];
